var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94845 47.3223H44.9558V25.0889H5.94845V47.3223ZM9.53698 31.3479C9.94842 31.3479 10.3558 31.2673 10.7359 31.1105C11.116 30.9536 11.4613 30.7238 11.7522 30.4339C12.0431 30.1442 12.2738 29.8003 12.4312 29.4217C12.5885 29.0432 12.6694 28.6374 12.6693 28.2277H38.2339C38.2339 29.0553 38.5639 29.8489 39.1517 30.4341C39.7392 31.0192 40.5362 31.3479 41.3671 31.3479V41.055C40.5362 41.055 39.7392 41.3836 39.1517 41.9688C38.5639 42.5539 38.2339 43.3476 38.2339 44.1752H12.6693C12.6694 43.7655 12.5885 43.3597 12.4312 42.9812C12.2738 42.6026 12.0431 42.2586 11.7522 41.9689C11.4613 41.6791 11.116 41.4492 10.7359 41.2924C10.3558 41.1356 9.94842 41.055 9.53698 41.055V31.3479Z",
    fill: "#52682F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.452 40.8874C28.0477 40.8874 30.152 38.792 30.152 36.2071C30.152 33.6223 28.0477 31.5268 25.452 31.5268C22.8562 31.5268 20.752 33.6223 20.752 36.2071C20.752 38.792 22.8562 40.8874 25.452 40.8874Z",
    fill: "#52682F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99803 23.5331H46.522V41.4783L49.6679 41.1464L47.3345 19.0416L7.99803 23.5331Z",
    fill: "#52682F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.658 13.0565L10.1122 21.3693L48.7205 17.3301L50.658 35.6695L53.8664 34.902L49.658 13.0565Z",
    fill: "#52682F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.65191c9626b2009b3624a244ac484ad6.svg";
export { ForwardRef as ReactComponent };